import React from "react";
import moment from 'moment';
import AddToCalendar from 'react-add-to-calendar';
import {
  ModalHeader,
  ModalBody
} from "reactstrap";
import singleLogo from "../../img/logo-small.png";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock, faCalendarPlus
} from "@fortawesome/free-solid-svg-icons";


import "react-add-to-calendar/dist/react-add-to-calendar.css";
import "./Calendar.css";

library.add(faClock, faCalendarPlus);

class Success extends React.Component {

  render() {

    const eventDetail = this.props.eventDetail;

    let start_time = moment(eventDetail.date).format('DD-MM-YYYY') + " " + eventDetail.start_time;
    let end_time = moment(eventDetail.date).format('DD-MM-YYYY') + " " + eventDetail.end_time;
    let event = {
      title: eventDetail.title,
      description: eventDetail.desc,
      startTime: moment(start_time, "DD-MM-YYYY hh:mm:ss").format('YYYY-MM-DDTHH:mm:ss.ss') + "+01:00",
      endTime: moment(end_time, "DD-MM-YYYY hh:mm:ss").format('YYYY-MM-DDTHH:mm:ss.ss') + "+01:00",
    };

    return (
      <div className="registration_success">
        <ModalHeader>
          <img src={singleLogo} className="img-fluid singleLogo" alt="Integrator" />
        </ModalHeader>
        <ModalBody>
          <p className="text-center text-complete">Registration Complete</p>
          <h3 className="text-center text-thank">Thank You!</h3>
          <p className="text-center event-title">Certified Integrator</p>
          <p className="text-center event-date">{moment(eventDetail.date).format('dddd Do MMMM YYYY')}</p>
          <p className="text-center event-time"><FontAwesomeIcon className="oi" icon="clock" />{eventDetail.time}</p>
          <div className="text-center">
            <AddToCalendar event={event} listItems={[{ google: 'Google' }, { apple: 'iCloud' }]} />
          </div>
        </ModalBody>
      </div>
    );
  }
}

export default Success;
